import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import api from "_api";
import { useAuth } from "hooks/useAuth";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen,
  fetchData,
  fetchProductData
) => {
  const { role } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",
      width: "50px",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Checkbox
          checked={selected[row.values.id] || false}
          onChange={() => handleCheckboxChange(row.values.id)}
        />
      ),
    },
    {
      Header: "ลำดับ",
      accessor: "index",
      disableSortBy: true,
    },
    { Header: "ผู้ใช้งาน", accessor: "username", showInFilter: false },
    { Header: "ชื่อ-นามสกุล", accessor: "name", showInFilter: false },
    { Header: "owner", accessor: "owner", showInFilter: false },
    {
      Header: "ชื่อร้าน/บริษัท",
      accessor: "company_name",
      showInFilter: false,
    },
    { Header: "โรงรับจำนำ", accessor: "package_type1", showInFilter: false },
    { Header: "รถมือสอง", accessor: "package_type2", showInFilter: false },
    { Header: "ที่ดิน", accessor: "package_type3", showInFilter: false },
    { Header: "สถานะ", accessor: "status", showInFilter: false },
    { Header: "อนุมัติ", accessor: "approved", showInFilter: false },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div>
          <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && activeRowId === row.id}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                console.log("fetchData", fetchData[row.index - 1]);
                setViewProduct(fetchData[row.index - 1]);
                handleViewOpen();
                handleMenuClose();
              }}
            >
              <RemoveRedEyeIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />

              <span style={{ marginLeft: "8px", color: "#737373" }}>
                ดูรายละเอียด
              </span>
            </MenuItem>
            {role !== "SuperAdminA" && (
              <>
                <MenuItem
                  onClick={() => {
                    setProduct(fetchData[row.index - 1]);
                    handleModalOpen();
                    handleMenuClose();
                  }}
                >
                  <BorderColorIcon
                    style={{ marginRight: "8px", color: "#737373" }}
                  />
                  <span style={{ marginLeft: "8px", color: "#737373" }}>
                    แก้ไข
                  </span>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    Swal.fire({
                      icon: "warning",
                      title: `คุณต้องการจะลบผู้ใช้งาน ${
                        fetchData[row.index - 1].username
                      } ใช่หรือไม่`,
                      text: "หากลบแล้วบัญชีผู้ใช้คนนี้จะไม่สามารถกู้คืนได้",
                      confirmButtonText: "ยืนยัน",
                      showCancelButton: true,
                      cancelButtonText: "ยกเลิก",
                      reverseButtons: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        const result = api.super_admin
                          .deleteUser(fetchData[row.index - 1].user_id)
                          .then((result) => {
                            if (result.isStatus) {
                              Swal.fire({
                                title: "สำเร็จ",
                                text: "บัญชีผู้ใช้นี้ถูกลบเรียบร้อย",
                                icon: "success",
                                timer: 2000,
                                showConfirmButton: false,
                              }).then((result) => {
                                if (result.isDismissed) {
                                  fetchProductData();
                                }
                              });
                            }
                          });
                      } else if (result.isDismissed) {
                        handleMenuClose();
                      } else if (result.isDenied) {
                        handleMenuClose();
                      }
                    });
                  }}
                >
                  <DeleteIcon
                    style={{ marginRight: "8px", color: "#737373" }}
                  />
                  <span style={{ marginLeft: "8px", color: "#737373" }}>
                    ลบ
                  </span>
                </MenuItem>
              </>
            )}
          </Menu>
        </div>
      ),
    },
  ];

  return columns;
};

export default useColumns;
